export default function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeAll(string: string) {
    return string.split(/([._-\s])/g)
        .map(substring => substring.charAt(0).toUpperCase() + substring.slice(1))
        .join("");
}